import { render } from "./Period_0.vue?vue&type=template&id=99f2fb6c"
import script from "./Period_0.vue?vue&type=script&lang=js"
export * from "./Period_0.vue?vue&type=script&lang=js"

import "./Period_0.vue?vue&type=style&index=0&id=99f2fb6c&lang=scss"
script.render = render

export default script